import { render, staticRenderFns } from "./PaintedFingerClue.vue?vue&type=template&id=62aaab64&"
import script from "./PaintedFingerClue.vue?vue&type=script&lang=js&"
export * from "./PaintedFingerClue.vue?vue&type=script&lang=js&"
import style0 from "./PaintedFingerClue.vue?vue&type=style&index=0&id=62aaab64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports